/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceReportedCalibrationData
 */
export interface DeviceReportedCalibrationData {
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceReportedCalibrationData
     */
    creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceReportedCalibrationData
     */
    lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    calibrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceReportedCalibrationData
     */
    $type?: DeviceReportedCalibrationDataTypeEnum;
}


/**
 * @export
 */
export const DeviceReportedCalibrationDataTypeEnum = {
    PtwPtw100AppZeroCoreSharedDeviceComponentCalibrationDeviceReportedCalibrationDataPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.DeviceComponent.Calibration.DeviceReportedCalibrationData, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type DeviceReportedCalibrationDataTypeEnum = typeof DeviceReportedCalibrationDataTypeEnum[keyof typeof DeviceReportedCalibrationDataTypeEnum];


/**
 * Check if a given object implements the DeviceReportedCalibrationData interface.
 */
export function instanceOfDeviceReportedCalibrationData(value?: unknown): value is DeviceReportedCalibrationData {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DeviceReportedCalibrationDataTypeEnum)[0];
}

export function DeviceReportedCalibrationDataFromJSON(json: any): DeviceReportedCalibrationData {
    return DeviceReportedCalibrationDataFromJSONTyped(json, false);
}

export function DeviceReportedCalibrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceReportedCalibrationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'calibrationCertificateNumber': !exists(json, 'calibrationCertificateNumber') ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': !exists(json, 'calibrationDate') ? undefined : json['calibrationDate'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DeviceReportedCalibrationDataToJSON(value?: DeviceReportedCalibrationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'creationTime': value.creationTime,
        'creatorUserId': value.creatorUserId,
        'lastModificationTime': value.lastModificationTime,
        'lastModifierUserId': value.lastModifierUserId,
        'deviceId': value.deviceId,
        'masterDeviceId': value.masterDeviceId,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'calibrationDate': value.calibrationDate,
        '$type': value.$type,
    });
}

